module.exports = "https://web-assets-production.autolist.com/_next/static/images/atlanta-ga-86d183d873d9b04a45f4de4cb2482572.jpg";